import { createFileRoute } from "@tanstack/react-router";
import { IntegrateApiReferencePage } from "@/features/agent-integrate/pages/api-reference-page";

// Thin shim: the agent-plane endpoint map plus the door to the contract-first reference.
export const Route = createFileRoute("/_authed/tenants/$slug/agents/integrate/api")({
  component: IntegrateApiReferencePage,
});
